"use client";

import React from "react";
import Link from "next/link";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const Error: React.FC<ErrorProps> = ({ error, reset }) => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center text-center py-20 dark:bg-slate-900">
      <img src="/assets/images/all-img/500.svg" alt="500 Error" />
      <div className="max-w-[546px] mx-auto w-full mt-12">
        <h4 className="text-slate-900 dark:text-white mb-4">Something went wrong</h4>
        <div className="dark:text-white text-base font-normal mb-10">
          We're sorry, but something unexpected happened
        </div>
      </div>

      <div className="max-w-[300px] mx-auto w-full flex flex-col gap-3">
        <button
          onClick={() => reset()}
          className="btn bg-primary-500 hover:bg-primary-600 text-white transition-all duration-150 block text-center w-full"
        >
          Try again
        </button>
        <Link
          href="/"
          className="btn bg-white hover:bg-opacity-75 transition-all duration-150 block text-center"
        >
          Go to homepage
        </Link>
      </div>
    </div>
  );
};

export default Error;